import { DetalleRegimenLaboralHEDTO, RegimenLaboralHEDTO } from 'components/DirectivoUnidad/Horas Extras/PlanificacionHE/TypesPlanificacionHE';
import React, { useMemo, useState } from 'react'
import { Card, CardBody, CardTitle, CardFooter, Row, Col,Button } from "reactstrap"
import { DetalleRegimenLaboralProyeccionHEDTO } from './TypesProyeccionDirectivo';

type PropsCardRegimenHE = {
    index:number,
    regimenLaboralProy:DetalleRegimenLaboralProyeccionHEDTO
}



export default function CardRegimenHE(props: PropsCardRegimenHE ) {

  const {
    regimenLaboralProy,
    index
  } = props
  let TITULO_CARD = props.regimenLaboralProy.siglasRegimenLaboral;

  const color = getColor(props.index);  // Función para obtener el color basado en el índice

    // Función para seleccionar un color
    function getColor(index: number) {
        const colors = ['#243561', '#57b631', '#FF7E01'];
        return colors[index % colors.length];  // Usa el módulo para rotar a través de los colores
    }



    
  
  return (
    <Card className="same-height-card">
      <CardTitle className="cardHeaderRegimenPlanificacion" style={{ backgroundColor: color }}  >
      {TITULO_CARD}

      </CardTitle>

      <CardBody>
            <Row>
                <Col xl={12}>
                    <div className='groupInfoRegimenPUTH'>
                        <div className='labelInfoRegimenGrayPUTH'> HORAS SUPLEMENTARIAS: </div>
                        <div className='valueInfoRegimenPUTH'> {regimenLaboralProy.horasSuplementarias}</div>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xl={12}>
                    <div className='groupInfoRegimenPUTH'>
                        <div className='labelInfoRegimenGrayPUTH'> HORAS EXTRAORDINARIAS: </div>
                        <div className='valueInfoRegimenPUTH'> {regimenLaboralProy.horasExtraordinarias}</div>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xl={12}>
                    <div className='groupInfoRegimenPUTH'>
                        <div className='labelInfoRegimenBlackPUTH'> <strong>TOTAL DE HORAS PROYECTADAS:</strong></div>
                        <div className='valueInfoRegimenPUTH'> {(regimenLaboralProy.horasSuplementarias??0 )+ (regimenLaboralProy.horasExtraordinarias??0)} </div>
                    </div>
                </Col>
            </Row>
           
      </CardBody>


    </Card>
  )


}